import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { EmailSourceEntity } from './email-source.entity';
import { UserEntity } from './user.entity';

export type EmailSharingRuleScope = 'global' | 'connection';
export type EmailSharingRuleType = 'allow' | 'block';
export type EmailSharingRuleTargetType =
	| 'email_address'
	| 'client'
	| 'domain'
	| 'all';

@Entity('email_sharing_rule')
@Index(['scope', 'emailSourceId', 'ruleType', 'targetType', 'targetValue'], {
	unique: true,
})
@Index(['emailSourceId'])
@Index(['scope'])
@Index(['targetType'])
export class EmailSharingRuleEntity extends BaseEntity {
	@Column({
		name: 'scope',
		type: 'enum',
		enum: ['global', 'connection'],
	})
	public scope!: EmailSharingRuleScope;

	@Column({
		name: 'fk_email_source__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public emailSourceId!: number | null;

	@ManyToOne(() => EmailSourceEntity, { nullable: true, onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk_email_source__id' })
	public emailSource!: EmailSourceEntity | null;

	@Column({
		name: 'rule_type',
		type: 'enum',
		enum: ['allow', 'block'],
	})
	public ruleType!: EmailSharingRuleType;

	@Column({
		name: 'target_type',
		type: 'enum',
		enum: ['email_address', 'client', 'domain', 'all'],
	})
	public targetType!: EmailSharingRuleTargetType;

	@Column({ name: 'target_value', type: 'varchar', length: 255 })
	public targetValue!: string;

	@Column({
		name: 'fk_client__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public targetClientId!: number | null;

	@ManyToOne(() => ClientEntity, { nullable: true, onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk_client__id' })
	public targetClient!: ClientEntity | null;

	@Column({ name: 'is_override', type: 'boolean', default: false })
	public isOverride!: boolean;

	@Column({
		name: 'created_by_user_id',
		type: 'int',
		unsigned: true,
	})
	public createdByUserId!: number;

	@ManyToOne(() => UserEntity)
	@JoinColumn({ name: 'created_by_user_id' })
	public createdByUser!: UserEntity;

	@Column({ name: 'notes', type: 'varchar', length: 255, nullable: true })
	public notes!: string | null;
}
